import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Alert } from 'antd';
import { messageModel } from '../MessageModel';
import { ChatMessageItem } from './ChatMessageItem';
import { getSelfUserId } from '../MessageConfig';

interface ChatMessageListProps {
  roomId: number;
}

export const ChatMessageList: React.FC<ChatMessageListProps> = observer(
  ({ roomId }) => {
    const bottomRef = useRef<HTMLDivElement>(null);
    const selfId = getSelfUserId() || '';
    const messages = messageModel.getVisibleMessages(roomId);

    useEffect(() => {
      bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages.length, roomId]);

    return (
      <div className="message-list-scroll">
        <Alert
          type="info"
          showIcon
          message={
            messageModel.hasMoreHistory
              ? '仅展示近30天消息，更早记录请在 APP 中查看'
              : '仅展示近30天消息，更多历史请在 APP 中查看'
          }
          className="message-history-tip"
        />
        {messages.map((msg) => (
          <ChatMessageItem
            key={msg.id}
            message={msg}
            isSelf={msg.fromUserId === selfId}
          />
        ))}
        <div ref={bottomRef} />
      </div>
    );
  },
);
